import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import "./MapLI.scss";
import classNames from "classnames";
export default function MapListOfElements({ menuList, liClassName }) {
    return (_jsx(_Fragment, { children: menuList.map((item, index) => {
            return (_jsx("li", Object.assign({ className: classNames("list-item", liClassName) }, { children: item }), index));
        }) }, void 0));
}
//# sourceMappingURL=MapLI.js.map